import React from 'react';
import { useParams } from 'react-router-dom';

import { Page } from '@nearst/ui';
import { useShop } from '@services/ShopProvider';
import InventoryViewer from './InventoryViewer';

const Inventory = () => {
	const { shop } = useShop();
	const { shopId } = useParams();

	// The empty state should only fire on a per-shop route where the shop couldn't be loaded.
	// On the org-level route (no :shopId in the URL) shop will also be empty, but InventoryViewer
	// handles the org case via stockSearch — it queries the organisation-inventory collection.
	if (shopId && !shop?.id) {
		return (
			<>
				<Page.Header>
					<h1>Manage items</h1>
				</Page.Header>
				<Page.Section>
					<p>
						We don't have any inventory details for your account yet. Please contact us at{' '}
						<a href="mailto:support@near.st">support@near.st</a> to get set up.
					</p>
				</Page.Section>
			</>
		);
	}

	return (
		<>
			<Page.Header>
				<h1>Manage items</h1>
				<p>Customise images, descriptions and channel visibility per product.</p>
				{shop?.quantityBuffer > 0 && (
					<p>
						A quantity buffer of <strong>{shop.quantityBuffer}</strong> is applied to this shop. The quantities shown reflect a
						reduction of {shop.quantityBuffer} from the actual stock count.
					</p>
				)}
			</Page.Header>
			<Page.Section>
				<InventoryViewer />
			</Page.Section>
		</>
	);
};

export default Inventory;
